import { render, staticRenderFns } from "./STT.vue?vue&type=template&id=8e80370e&scoped=true"
import script from "./STT.vue?vue&type=script&lang=js"
export * from "./STT.vue?vue&type=script&lang=js"
import style0 from "./STT.vue?vue&type=style&index=0&id=8e80370e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e80370e",
  null
  
)

export default component.exports